
import React from 'react';
import MultiItemInput from '../MultiItemInput';
import FormInput from '../FormInput';
import { PoliticalStakeholders } from '../../types';

interface StakeholdersFormProps {
  data: PoliticalStakeholders;
  onChange: (field: string, value: string) => void;
  onArrayChange: (field: string, value: string[]) => void;
}

const StakeholdersForm: React.FC<StakeholdersFormProps> = ({
  data,
  onChange,
  onArrayChange
}) => {
  return (
    <div className="animate-fade-in">
      <h3 className="text-lg font-medium mb-4">Political Stakeholders</h3>
      
      <MultiItemInput
        id="government_officials"
        label="Key Government Officials and Decision-Makers"
        placeholder="e.g., Minister Johnson, Department Head Smith, Agency Director Wilson"
        items={data.government_officials}
        onChange={(items) => onArrayChange('government_officials', items)}
      />
      
      <MultiItemInput
        id="politicians"
        label="Politicians and Elected Officials"
        placeholder="e.g., Senator Davis, MP Thompson, Mayor Rodriguez"
        items={data.politicians}
        onChange={(items) => onArrayChange('politicians', items)}
      />
      
      <MultiItemInput
        id="bureaucrats"
        label="Key Bureaucrats and Civil Servants"
        placeholder="e.g., Policy Director, Chief of Staff, Program Manager"
        items={data.bureaucrats}
        onChange={(items) => onArrayChange('bureaucrats', items)}
      />
      
      <MultiItemInput
        id="political_allies"
        label="Political Allies and Supporters"
        placeholder="e.g., Progressive Coalition, Labor Council, Advocacy Groups"
        items={data.political_allies}
        onChange={(items) => onArrayChange('political_allies', items)}
      />
      
      <MultiItemInput
        id="opposition_groups"
        label="Opposition Groups and Opponents"
        placeholder="e.g., Industry Association, Conservative Coalition, Opposition Politicians"
        items={data.opposition_groups}
        onChange={(items) => onArrayChange('opposition_groups', items)}
      />
      
      <MultiItemInput
        id="voters_constituents"
        label="Key Voter Groups and Constituencies"
        placeholder="e.g., Union Members, Healthcare Workers, Small Business Owners"
        items={data.voters_constituents}
        onChange={(items) => onArrayChange('voters_constituents', items)}
      />
      
      <MultiItemInput
        id="media_outlets"
        label="Important Media Outlets and Journalists"
        placeholder="e.g., Local News, Industry Publications, Key Reporters"
        items={data.media_outlets}
        onChange={(items) => onArrayChange('media_outlets', items)}
      />
      
      <MultiItemInput
        id="union_leadership"
        label="Union Leaders and Labor Organizations"
        placeholder="e.g., Union President, State Labor Council, Shop Stewards"
        items={data.union_leadership}
        onChange={(items) => onArrayChange('union_leadership', items)}
      />
      
      <FormInput
        id="community_context"
        label="Community Context and Political Environment"
        placeholder="Describe the political climate, community attitudes, and organizing potential"
        value={data.community_context}
        onChange={(e) => onChange('community_context', e.target.value)}
        multiline
        rows={4}
      />
    </div>
  );
};

export default StakeholdersForm;
